import React from "react";
import { Checkbox } from "@mui/material";

const DSCheckbox = (props: React.ComponentProps<typeof Checkbox>) => {
  return <Checkbox {...props} />;
};

export default DSCheckbox;
